/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSessionAnalysis = /* GraphQL */ `
  query GetSessionAnalysis($id: ID!) {
    getSessionAnalysis(id: $id) {
      id
      sessionId
      userId
      specialty
      analysisResult
      diagnoses {
        code
        description
        __typename
      }
      isSigned
      signedBy
      signedAt
      addendums {
        text
        addedBy
        addedAt
        __typename
      }
      orgUuid
      pccPatientId
      noteType
      externalId
      pushedToPCC
      pccPushAt
      timeIn
      timeOut
      durationMinutes
      isManualTimeEntry
      pccNoteId
      pccNoteStatus
      pccLastSyncedAt
      pccDeletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSessionAnalyses = /* GraphQL */ `
  query ListSessionAnalyses(
    $filter: ModelSessionAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionAnalyses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        userId
        specialty
        analysisResult
        isSigned
        signedBy
        signedAt
        orgUuid
        pccPatientId
        noteType
        externalId
        pushedToPCC
        pccPushAt
        timeIn
        timeOut
        durationMinutes
        isManualTimeEntry
        pccNoteId
        pccNoteStatus
        pccLastSyncedAt
        pccDeletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCodingAnalysis = /* GraphQL */ `
  query GetCodingAnalysis($id: ID!) {
    getCodingAnalysis(id: $id) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCodingAnalyses = /* GraphQL */ `
  query ListCodingAnalyses(
    $filter: ModelCodingAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCodingAnalyses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        caseName
        patientReference
        inputDocumentKeys
        processingStatus
        resultJson
        errorJson
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
